// API
import BaseApi from './base';

class RatificantesApi extends BaseApi {
  constructor() {
    super('ratificantes');
  }

  postClonados(data, params = {}) {
    return this.request.post(`/ratificantes/clonados`, data, {
      params: {
        ...params
      }
    });
  }
}

export default new RatificantesApi();
